class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="m3.644 11.646 3.999-3.998.707.707-3.999 3.998-.707-.707ZM8.5 15a.499.499 0 0 1-.495-.43l-.5-3.5 1-.14.375 2.635 1.62-1.305V8.5a.5.5 0 0 1 .145-.355L12.68 6.11A4.47 4.47 0 0 0 14 2.93V2h-.93a4.47 4.47 0 0 0-3.18 1.32L7.855 5.355A.5.5 0 0 1 7.5 5.5H3.74L2.435 7.13l2.635.375-.14 1-3.5-.5a.5.5 0 0 1-.32-.81l2-2.5A.5.5 0 0 1 3.5 4.5h3.795L9.18 2.61A5.46 5.46 0 0 1 13.07 1H14a1 1 0 0 1 1 1v.93a5.46 5.46 0 0 1-1.61 3.89L11.5 8.705V12.5a.5.5 0 0 1-.19.39l-2.5 2a.5.5 0 0 1-.31.11Z" clip-rule="evenodd"></path></svg>';
  }
}
const e = "pi-rocket";
customElements.get(e) || customElements.define(e, t);
export {
  t as default
};
